export default __webpack_public_path__ + "static/media/meeting2.0354bd0f.png";